import { render, staticRenderFns } from "./WsUploadComponent.vue?vue&type=template&id=5e272c36&scoped=true"
import script from "./WsUploadComponent.vue?vue&type=script&lang=js"
export * from "./WsUploadComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e272c36",
  null
  
)

export default component.exports